<template>
  <!-- 固件管理 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 车辆类别 -->
        <el-form-item :label="$t('pages.equipment.text5')">
          <el-select
            v-model="searchParams.bikeCategoryId"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车辆型号 -->
        <el-form-item :label="$t('pages.equipment.text6')">
          <el-select
            v-model="searchParams.bikeTypeId"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in option"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 固件类别 -->
        <el-form-item :label="$t('pages.equipment.text198')">
          <el-select
            v-model="searchParams.hwType"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="item in opeting"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 硬件版本 -->
        <el-form-item :label="$t('pages.equipment.text199')">
          <el-select
            v-model="searchParams.hwVersion"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in optings"
              :key="index"
              :label="item.hwVersion"
              :value="item.hwVersion"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 上传时间 -->
        <el-form-item :label="$t('pages.system.text3')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
            @change="startChange"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- 按钮区域 -->
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['firmwareManagement:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['firmwareManagement:reset']"
        ></DiluButton>
      </div>
    </div>
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['firmwareManagement:add']"
      ></DiluButton>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column prop="date" label="#" width="50" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 车辆类别 -->
      <el-table-column
        prop="bikeCategotyName"
        :label="$t('pages.equipment.text5')"
        width="130"
        align="center"
      >
      </el-table-column>
      <!-- 车辆型号 -->
      <el-table-column
        prop="bikeTypeName"
        :label="$t('pages.equipment.text6')"
        align="center"
      >
      </el-table-column>
      <!-- 固件类别 -->
      <el-table-column
        prop="hwType"
        :label="$t('pages.equipment.text198')"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-for="(item, index) in opeting" :key="index">
              {{ item.value == scope.row.hwType ? item.label : "" }}
            </span>
          </div>
        </template>
      </el-table-column>
      <!-- 硬件版本 -->
      <el-table-column
        prop="hwVersion"
        :label="$t('pages.equipment.text199')"
        align="center"
      >
      </el-table-column>
      <!-- 固件名称 -->
      <el-table-column
        prop="firmwareName"
        :label="$t('pages.equipment.text200')"
        align="center"
      >
      </el-table-column>
      <!-- 固件版本 -->
      <el-table-column
        prop="fwVersion"
        :label="$t('pages.equipment.text201')"
        align="center"
      >
      </el-table-column>
      <!-- 上传时间 -->
      <el-table-column
        prop="createdAt"
        :label="$t('pages.system.text3')"
        align="center"
      >
      </el-table-column>
      <!-- 固件状态 -->
      <el-table-column
        prop="firmwareStatus"
        :label="$t('afterSales.text35')"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span>
              {{
                scope.row.firmwareStatus == "0"
                  ? $t("pages.operate.text4")
                  : $t("pages.operate.text5")
              }}
            </span>
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t("public.text4")
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- 查看 -->
                <el-dropdown-item
                  :command="{ type: 'see', data: scope.row }"
                  v-permission="['firmwareManagement:see']"
                  >{{ $t("button.look") }}</el-dropdown-item
                >
                <!-- 编辑 -->
                <el-dropdown-item
                  :command="{ type: 'edit', data: scope.row }"
                  v-permission="['firmwareManagement:edit']"
                  :disabled="!scope.row.editFlag"
                  >{{ $t("button.edit") }}</el-dropdown-item
                >
                <!-- 禁用 -->
                <el-dropdown-item
                  :command="{ type: 'disable', data: scope.row }"
                  v-permission="['firmwareManagement:edit']"
                  :disabled="!scope.row.disableFlag"
                  >{{ $t("pages.operate.text5") }}</el-dropdown-item
                >
                <!-- 删除 -->
                <el-dropdown-item
                  :command="{ type: 'remove', data: scope.row }"
                  v-permission="['firmwareManagement:remove']"
                  :disabled="!scope.row.deleteFlag"
                  >{{ $t("button.delete") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <FirmwareManagementAddModule
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      :options="options"
      :opeting="opeting"
      @firmwareManagementList="firmwareManagementList"
      :dialogStatus="dialogStatus"
      :currentAgreement="currentAgreement"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { resetDate } from "../../../utils/util/validate";
import FirmwareManagementAddModule from "./module/firmwareManagementAddModule";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      //选中的开始日期之前的日期禁选
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      dialogStatus: 0, // 当前弹窗状态
      currentAgreement: {}, //当前选中固件
      searchParams: {
        belongCustomerId: "", //客户id
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        hwType: "", //固件类别
        hwVersion: "", //硬件版本
        taskType: 1,
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
      },
      opeting: [
        {
          value: 10,
          label: this.$t("pages.equipment.text178"), //蓝牙
        },
        {
          value: 15,
          label: this.$t("pages.equipment.text202"), //电机控制器
        },
        {
          value: 20,
          label: this.$t("pages.equipment.text203"), //仪表
        },
        {
          value: 25,
          label: this.$t("pages.equipment.text204"), //电池
        },
        {
          value: 30,
          label: this.$t("pages.equipment.text205"), //中央控制器
        },
        {
          value: 35,
          label: this.$t("pages.equipment.text206"), //钢缆锁
        },
        {
          value: 40,
          label: this.$t("pages.equipment.text207"), //电池锁
        },
        {
          value: 45,
          label: this.$t("pages.equipment.text208"), //轮毂锁
        },
      ],
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true, //打开分页功能
      },
      total: 0,
      tableData: [],
      options: [],
      option: [],
      optings: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    FirmwareManagementAddModule,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.firmwareManagementList();
    this.equipmentModeListAll();
    this.firmwareManagementListAllCategory();
    this.firmwareManagementListAll();
  },
  methods: {
    //搜索
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.firmwareManagementList();
    },
    //操作
    handleCommand(e) {
      if (e.type == "see") {
        this.see(e.data);
      }
      if (e.type == "edit") {
        this.edit(e.data);
      }
      if (e.type == "disable") {
        this.disable(e.data);
      }
      if (e.type == "remove") {
        this.remove(e.data);
      }
    },
    //更改开始日期时间时结束日期时间置空重选
    startChange() {
      this.searchParams.stopAt = null;
    },
    //获取固件管理列表
    firmwareManagementList() {
      this.searchParams.belongCustomerId = this.platformData.id;
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3")); //请选择结束时间
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2")); //请选择开始时间
        }
      }
      this.request.firmwareManagementList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //车辆型号-查询所有
    equipmentModeListAll() {
      this.request.equipmentModeListAll().then((res) => {
        this.option = res.data;
      });
    },
    //车辆类别-查询所有
    firmwareManagementListAllCategory() {
      this.request.firmwareManagementListAllCategory().then((res) => {
        this.options = res.data;
      });
    },
    //硬件版本-查询所有
    firmwareManagementListAll() {
      this.request.listALlDistinctHwVersion().then((res) => {
        this.optings = res.data;
      });
    },
    //禁用
    disable(e) {
      this.$confirm(this.$t("omission.text62"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          this.request.firmwareManagementDisable("id=" + e.id).then(() => {
            this.$message.success(this.$t("public.text9"));
            this.firmwareManagementList();
          });
        })
        .catch(() => {});
    },
    //删除固件
    remove(e) {
      this.$confirm(
        this.$t("pages.equipment.text209"),
        this.$t("public.text6"),
        {
          confirmButtonText: this.$t("button.determine"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let arr = [];
          arr.push(e.id);
          this.request.firmwareManagementDelete({ ids: arr }).then(() => {
            this.$message.success(this.$t("public.text7"));
            this.firmwareManagementList();
          });
        })
        .catch(() => {});
    },
    //翻页
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.firmwareManagementList();
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //新增
    add() {
      this.dialogStatus = 0;
      this.dialogVisible = true;
    },
    //查看
    see(e) {
      this.dialogStatus = 2;
      this.currentAgreement = e;
      this.dialogVisible = true;
    },
    //编辑
    edit(e) {
      this.dialogStatus = 1;
      this.currentAgreement = e;
      this.dialogVisible = true;
    },
    //重置
    reset() {
      this.searchParams = {
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        hwType: "", //固件类别
        hwVersion: "", //硬件版本
        taskType: 1,
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
      };
      this.total = 0;
      this.firmwareManagementList();
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>